<template>
  <section>
    <validation-observer ref="courseForm" #default="{ invalid }">
      <b-form @submit.prevent="courseForm" v-if="!loading">
        <b-row>
          <b-col cols="12" xl="9" md="8">
            <b-card>
              <b-row>
                <b-col cols="12" md="6">
                  <b-form-group
                    label=" * نام دوره"
                    label-for="add-course-phone"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="name"
                      vid="name"
                      rules="required|min:4"
                    >
                      <b-form-input
                        autocomplete="on"
                        id="add-course-name"
                        v-model="name"
                        name="add-course-name"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <div class="d-flex justify-content-between flex-wrap">
                    <b-form-group
                      label="تاریخ شروع ثبت نام"
                      label-for="add-course-available-at"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="available-at"
                        vid="available-at"
                      >
                        <date-picker
                          v-model="available_at"
                          autocomplete="on"
                          id="add-course-available-at"
                          type="datetime"
                          clearable
                          name="add-course-available-at"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <b-form-group
                      label="تاریخ پایان ثبت نام"
                      label-for="add-course-unavailable-at"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="unavailable-at"
                        vid="unavailable-at"
                      >
                        <date-picker
                          v-model="unavailable_at"
                          autocomplete="on"
                          id="add-course-unavailable-at"
                          type="datetime"
                          clearable
                          name="add-course-unavailable-at"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>
                  <div class="d-flex justify-content-between flex-wrap">
                    <b-form-group
                      label="شروع دوره"
                      label-for="add-course-started-at"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="started-at"
                        vid="started-at"
                      >
                        <date-picker
                          v-model="started_at"
                          autocomplete="on"
                          id="add-course-started-at"
                          type="datetime"
                          clearable
                          name="add-course-started-at"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                    <b-form-group
                      label="پایان دوره"
                      label-for="add-course-ended-at"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="ended-at"
                        vid="ended-at"
                      >
                        <date-picker
                          v-model="ended_at"
                          autocomplete="on"
                          id="add-course-ended-at"
                          type="datetime"
                          clearable
                          name="add-course-ended-at"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </div>
                  <b-form-group
                    label=" * طول دوره"
                    label-for="add-course-duration"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="duration"
                      vid="duration"
                      rules="required"
                    >
                      <b-form-input
                        type="number"
                        autocomplete="on"
                        id="add-course-duration"
                        v-model="duration"
                        name="add-course-duration"
                        :state="errors.length > 0 ? false : null"
                        min="1"
                      />

                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group label-for="add-course-active">
                    <b-form-checkbox
                      v-model="active"
                      name="check-active"
                      switch
                      inline
                      :uncheckedValue="0"
                      :value="1"
                    >
                      وضعیت دوره
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-checkbox
                    v-model="penalty"
                    name="check-penalty"
                    class="my-2 pb-50"
                    switch
                    inline
                    :uncheckedValue="0"
                    :value="1"
                  >
                    محاسبه جریمه
                  </b-form-checkbox>
                  <b-form-group
                    label=" * بازه جریمه (دقیقه)"
                    label-for="add-course-penalty_duration"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="penalty_duration"
                      vid="penalty_duration"
                      :rules="penalty != 0 ? 'required' : ''"
                    >
                      <b-form-input
                        autocomplete="on"
                        id="add-course-penalty_duration"
                        type="number"
                        min="30"
                        v-model="penalty_duration"
                        :disabled="penalty == 0"
                        :state="
                          penalty != 0 && errors.length > 0 ? false : null
                        "
                        class="mb-1"
                      />
                      <small class="text-danger" v-if="penalty != 0">{{
                        errors[0]
                      }}</small>
                    </validation-provider>
                  </b-form-group>

                  <b-form-group
                    label=" * قیمت دوره را وارد کنید (تومان)"
                    label-for="add-course-amount"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="amount"
                      vid="amount"
                      rules="required"
                    >
                      <b-form-input
                        autocomplete="on"
                        id="add-course-amount"
                        type="number"
                        min="0"
                        v-model="amount"
                        :state="errors.length > 0 ? false : null"
                        class="mb-1"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <b-form-checkbox
                    v-model="percentage"
                    name="check-isPercentage"
                    switch
                    inline
                    class="mt-2"
                    :uncheckedValue="0"
                    :value="1"
                  >
                    {{
                      percentage
                        ? "نوع تخفیف درصد (٪)"
                        : " نوع تخفیف مقدار (تومان) "
                    }}
                  </b-form-checkbox>
                  <b-form-group
                    label="تخفیف"
                    label-for="add-course-rebate"
                    class="my-1"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="rebate"
                      vid="rebate"
                    >
                      <b-form-input
                        autocomplete="on"
                        id="add-course-rebate"
                        v-model="rebate"
                        class="mb-1"
                        type="number"
                        min="0"
                        :max="percentage ? '100' : ''"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group label-for="add-course-separate">
                    <b-form-checkbox
                      v-model="separate"
                      name="check-separate"
                      switch
                      inline
                      :uncheckedValue="0"
                      :value="1"
                    >
                      قابلیت خرید دوره جدا از ترم
                    </b-form-checkbox>
                  </b-form-group>
                  <hr class="my-1" />
                  <div class="d-flex my-2 w-100 justify-content-between">
                    <span>قیمت نهایی</span>
                    <span>{{ numberWithCommas(finalAmount) }} تومان</span>
                  </div>
                </b-col>
              </b-row>
              <hr class="my-2" />
              <b-row>
                <!-- <b-col cols="12" md="6">
                  <semesters
                    :propSemesters="course.semesters"
                    v-model="course.semesters"
                  />
                </b-col> -->
                <b-col cols="12" md="6">
                  <b-form-group
                    label="مدرسین دوره"
                    label-for="add-course-teachers"
                    class="w-100"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="teachers"
                      vid="teachers"
                      class="d-flex justify-content-start align-items-center"
                    >
                      <select-box
                        v-model="teachers"
                        multiple
                        class="w-100"
                        label="text"
                        select="id"
                        url="user"
                        searchable
                      >
                      </select-box>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <hr class="my-2" />
              <b-row>
                <b-col cols="12" md="6">
                  <b-form-group
                    label="پیش نیاز های دوره"
                    label-for="add-course-prerequisites"
                    class="w-100"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="prerequisites"
                      vid="prerequisites"
                      class="d-flex justify-content-start align-items-center"
                    >
                      <select-box
                        v-model="prerequisites"
                        multiple
                        label="text"
                        select="id"
                        class="w-100"
                        url="course"
                        searchable
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-group
                    label="رویداد ها"
                    label-for="add-course-events"
                    class="w-100"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="events"
                      vid="events"
                      class="d-flex justify-content-start align-items-center"
                    >
                      <select-box
                        v-model="events"
                        multiple
                        label="text"
                        select="id"
                        class="w-100"
                        url="event"
                        searchable
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <hr class="my-2" />
              <b-row>
                <b-col>
                  <div>
                    <b-button
                      variant="gradient-primary"
                      class="d-flex align-items-center"
                      @click="addTopic"
                    >
                      <span class="mr-1">سرفصل</span>
                      <feather-icon icon="PlusIcon" />
                    </b-button>
                    <draggable
                      v-model="topics"
                      class="list-group list-group-flush cursor-move"
                      tag="ul"
                    
                    >
                      <b-list-group-item
                        v-for="(topic, index) in topics"
                        :key="'topic-' + index"
                        tag="li"
                      >
                        <topic-row :topic="topic" v-model="newTopics[index]" />
                        <div
                          class="w-100 d-flex justify-content-end"
                          v-if="topics.length > 1"
                        >
                          <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="danger"
                            class="btn-icon rounded-circle my-1"
                            @click="removeTopic(index)"
                          >
                            <feather-icon icon="TrashIcon" />
                          </b-button>
                        </div>
                      </b-list-group-item>
                    </draggable>
                  </div>
                </b-col>
              </b-row>
              <hr class="my-2" />
              <b-row>
                <b-col>
                  <faq :faqs="faqs" v-model="faqs" />
                </b-col>
              </b-row>
              <hr class="my-2" />

              <b-row>
                <b-col>
                  <b-form-group
                    label="توضیحات مختصر"
                    label-for="add-semester-brief_description"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="brief_description"
                      vid="brief_description"
                    >
                      <editor
                        v-model="brief_description"
                        :content="brief_description"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr class="my-2" />
              <b-row>
                <b-col>
                  <b-form-group
                    label="توضیحات"
                    label-for="add-course-description"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="description"
                      vid="description"
                    >
                      <editor v-model="description" :content="description" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="12" md="4" xl="3" class="invoice-actions mt-md-0 mt-2">
            <b-card>
              <b-form-group
                label="انتخاب بنر برای دوره"
                label-for="add-course-banner"
              >
                <validation-provider
                  #default="{ errors }"
                  name="banner"
                  vid="banner"
                  class="d-flex justify-content-start align-items-center w-100"
                >
                  <upload-file
                    class="w-100"
                    @uploadImage="uploadImage"
                    :banner="banner"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <hr class="my-2" />
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mb-75"
                block
                type="submit"
                :disabled="invalid"
              >
                {{ $route.params.id ? "ویرایش دوره" : "ایجاد دوره" }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="mb-75"
                block
                :to="{ name: 'add-session' }"
              >
                ایجاد جلسه
              </b-button>
              <b-button
                :to="{ name: 'courses' }"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                block
              >
                برگشت به لیست دوره ها
              </b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <loader :loading="loading" />
  </section>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BBadge,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BFormTextarea,
  BImg,
  BCard,
  BCardTitle,
  BFormFile,
  BCardText,
  BAvatar,
  BListGroupItem,
  BModal,
} from "bootstrap-vue";

import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import Editor from "@/@core/components/editor/Editor.vue";
import Loader from "@/@core/components/loader/Loader.vue";
import UploadFile from "@/@core/components/upload-file/UploadFile.vue";
import TopicRow from "./TopicRow.vue";
import SelectBox from "@/@core/components/select-box/SelectBox.vue";
import Semesters from "./Semesters.vue";
import faq from "@core/components/faq/Faq.vue";
import draggable from "vuedraggable";
export default {
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BBadge,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    BFormTextarea,
    BFormFile,
    BAvatar,
    BModal,
    BCard,
    Loader,
    Editor,
    UploadFile,
    TopicRow,
    SelectBox,
    Semesters,
    faq,
    draggable,
    BListGroupItem,
  },
  directives: {
    Ripple,
  },
  computed: {
    finalAmount() {
      let finalAmount = 0;
      if (this.percentage) {
        finalAmount =
          Number(this.amount) -
          (Number(this.amount) * Number(this.rebate)) / 100;
      } else {
        finalAmount = Number(this.amount) - Number(this.rebate);
      }

      return finalAmount > 0 ? String(parseInt(finalAmount)) : "0";
    },
  },
  data() {
    return {
      name: "",
      description: "",
      brief_description: "",
      duration: "",
      amount: "",
      rebate: "",
      percentage: 0,
      separate: 0,
      active: 0,
      penalty_duration: "",
      penalty: 0,
      events: [],
      teachers: [],
      prerequisites: [],
      // semesters: [],
      topics: [],
      newTopics: [],
      available_at: "",
      unavailable_at: "",
      started_at: "",
      ended_at: "",
      banner: "",
      faqs: [],
      loading: false,
      required,
    };
  },
  created() {
    if (this.$route.params.id) {
      this.getCourse();
    }
  },
  watch: {
    penalty(val) {
      if (val == 0) {
        this.penalty_duration = "";
      }
    },
  },
  methods: {
    removeSession(id) {
      this.topics.splice(
        this.topic.sessions.findIndex((session) => session.id == id),
        1
      );
    },
    addTopic() {
      this.topics.push({
        title: "",
      });
    },
    removeTopic(i) {
      this.topics.splice(i, 1);
      this.newTopics.splice(i, 1);
    },
    uploadImage(e) {
      this.banner = e;
    },
    async getCourse() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `/panel/courses/${this.$route.params.id}?includes=sessions.prerequisites,sessions.exercises,roadmaps,prerequisites,teachers,events,faqs`
        );
        await Object.keys(data.data).map((key) => {
          key == "active"
            ? (this[key] = data.data[key] ? 1 : 0)
            : key == "percentage"
            ? (this[key] = data.data[key] ? 1 : 0)
            : key == "separate"
            ? (this[key] = data.data[key] ? 1 : 0)
            : key == "penalty"
            ? (this[key] = data.data[key] ? 1 : 0)
            : key == "penalty_duration"
            ? data.data["penalty"]
              ? (this[key] = data.data[key])
              : (this[key] = "")
            : key == "teachers"
            ? (this[key] = data.data[key].users.map((item) => item.id))
            : key == "prerequisites"
            ? (this[key] = data.data[key].courses.map((item) => item.id))
            : key == "available_at"
            ? (this[key] = this.calcDate(data.data[key]))
            : key == "unavailable_at"
            ? (this[key] = this.calcDate(data.data[key]))
            : key == "started_at"
            ? (this[key] = this.calcDate(data.data[key]))
            : key == "ended_at"
            ? (this[key] = this.calcDate(data.data[key]))
            : key == "faqs"
            ? (this[key] = data.data[key].faqs)
            : key == "events"
            ? (this[key] = data.data[key].events.map((item) => item.id))
            : // : item == "roadmaps"
            // ? (this.course["semesters"] = data.data[item].roadmaps.map(
            //     (item) => {
            //       return {
            //         id: item.semester_id,
            //         vip: item.vip ? 1 : 0,
            //       };
            //     }
            //   ))
            key == "topics"
            ? (this[key] = data.data[key].map((topic) => {
                topic.sessions = [];
                data.data.sessions.sessions.map((session) => {
                  if (session.pivot.topic == topic.key) {
                    topic.sessions[session.pivot.sort - 1] = {
                      id: session.pivot.session_id,
                      status: String(session.pivot.status),
                      started_at: this.calcDate(session.pivot.started_at),
                      finished_at: this.calcDate(session.pivot.finished_at),
                      exercises:
                        session.exercises && session.exercises.exercises
                          ? session.exercises.exercises.map((exercise) => {
                              return {
                                id: exercise.id,
                                started_at: this.calcDate(
                                  exercise.pivot.started_at
                                ),
                                deadline_at: this.calcDate(
                                  exercise.pivot.deadline_at
                                ),
                                duration: exercise.pivot.duration,
                              };
                            })
                          : [],
                      prerequisites: session.prerequisites.sessions.map(
                        (item) => item.id
                      ),
                    };
                  }
                });
                return topic;
              }))
            : key == "sessions"
            ? ""
            : (this[key] = data.data[key]);
        });
      } catch (err) {}
      this.loading = false;
    },
    courseForm() {
      this.$refs.courseForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          const course = await {
            unavailable_at: this.toGorgian(this.unavailable_at),
            started_at: this.toGorgian(this.started_at),
            ended_at: this.toGorgian(this.ended_at),
            available_at: this.toGorgian(this.available_at),
            name: this.name,
            description: this.description,
            brief_description: this.brief_description,
            faqs: this.faqs,
            duration: this.duration,
            amount: this.amount,
            penalty_duration: this.penalty_duration,
            penalty: this.penalty,
            rebate: this.rebate,
            percentage: this.percentage,
            separate: this.separate,
            active: this.active,
            events: this.events,
            teachers: this.teachers,
            prerequisites: this.prerequisites,
            topics: this.newTopics,
            banner: this.banner,
          };
          try {
            this.formData = await new FormData();
            await Object.keys(course).map((item, index) => {
              if (item == "rebate") {
                course[item] = course[item] ? course[item] : "0";
              }
              if (item == "banner" && course[item] instanceof File === false) {
                course[item] = "";
              }
              if (item == "faqs" && course[item]) {
                course[item] = course[item].map((item) => {
                  return {
                    id: item.id,
                    active: item.active ? 1 : 0,
                    question: item.question,
                    answer: item.answer,
                  };
                });
              }

              // if (item == "semesters") {
              //   course[item] = course[item].map((semester, index) => {
              //     if (Object.keys(semester).length) {
              //       return {
              //         id: semester.id,
              //         vip: semester.vip ? 1 : 0,
              //         sort: index + 1,
              //       };
              //     }
              //   });
              // }
              if (item == "topics") {
                course[item] = course[item].map((topic, index) => {
                  let topicObj = {};
                  topicObj.title = topic.title;
                  topicObj.key = topic.key;
                  topic.sessions &&
                    (topicObj.sessions = topic.sessions.map(
                      (session, index) => {
                        return {
                          id: session.id,
                          status: session.status || "",
                          sort: index + 1,
                          started_at: this.toGorgian(session.started_at) || "",
                          finished_at:
                            this.toGorgian(session.finished_at) || "",
                          prerequisites: session.prerequisites || [],
                          exercises:
                            session.exercises && session.exercises.length
                              ? session.exercises.map((exercise, index) => {
                                  if (
                                    session.exercises[index] &&
                                    session.exercises[index].id
                                  ) {
                                    return {
                                      id: exercise.id,
                                      started_at: this.toGorgian(
                                        exercise.started_at
                                      ),
                                      sort: index + 1,
                                      deadline_at: this.toGorgian(
                                        exercise.deadline_at
                                      ),
                                      duration: exercise.duration,
                                    };
                                  } else {
                                    return {};
                                  }
                                })
                              : [],
                        };
                      }
                    ));
                  return topicObj;
                });
              }
              this.setFormData(course[item], index, item);
            });

            if (this.$route.params.id) {
              const { data } = await this.$http.post(
                `/panel/courses/${this.$route.params.id}`,
                this.formData,
                {
                  params: {
                    _method: "put",
                  },
                }
              );
              await this.getCourse();
            } else {
              const { data } = await this.$http.post(
                `/panel/courses`,
                this.formData
              );
              this.unavailable_at = "";
              this.started_at = "";
              this.ended_at = "";
              this.available_at = "";
              this.name = "";
              this.description = "";
              this.duration = "";
              this.amount = "";
              this.rebate = 0;
              this.penalty_duration = "";
              this.penalty = 0;
              this.percentage = 0;
              this.separate = 0;
              this.active = 0;
              this.events = [];
              this.teachers = [];
              this.prerequisites = [];
              this.topics = [];
              this.banner = "";
            }
            this.loading = false;
            this.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: `اطلاعات شما با موفقیت ثبت شد.`,
                  icon: "CoffeeIcon",
                  variant: "success",
                },
              },
              { position: "bottom-right" }
            );
          } catch (err) {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
.vpd-input-group {
  .vpd-icon-btn {
    margin-bottom: 0;
  }
  .form-control {
    border-radius: 0;
  }
}
</style>
